import React from 'react';
import {
  Box,
  IconButton,
  Typography,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

interface DetailSidebarProps {
  title: string;
  onClose: () => void;
  toolbar?: React.ReactNode;
  children: React.ReactNode;
}

const DetailSidebar: React.FC<DetailSidebarProps> = ({
  title,
  onClose,
  toolbar,
  children,
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.default',
        borderLeft: '1px solid',
        borderColor: 'divider',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          px: 2,
          py: 1,
          borderBottom: 1,
          borderColor: 'divider',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexShrink: 0,
        }}
      >
        <Typography variant="subtitle2" fontWeight={600}>
          {title}
        </Typography>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      {toolbar && (
        <Box sx={{ flexShrink: 0 }}>
          {toolbar}
        </Box>
      )}

      <Box sx={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
        {children}
      </Box>
    </Box>
  );
};

export default DetailSidebar;
